export type ThrottledAction = () => (void | Promise<void>);

export class WithWarmup {
    action: ThrottledAction;
    warmup: number;
    timeoutId: number;

    constructor(action: ThrottledAction, warmup: number) {
        this.action = action;
        this.warmup = warmup;

        this.timeoutId = -1;
    }

    trigger() {
        if (this.timeoutId != -1) return;

        // stfu tsc
        // @ts-ignore
        this.timeoutId = setTimeout(async () => {
            let value = this.action();
            if (typeof value == "object" && "then" in value)
                await <Promise<void>>value;

            this.timeoutId = -1;
        }, this.warmup)
    }
}

export class WithResettingWarmup {
    action: ThrottledAction;
    warmup: number;
    timeoutId: number;

    constructor(action: ThrottledAction, warmup: number) {
        this.action = action;
        this.warmup = warmup;

        this.timeoutId = -1;
    }

    trigger() {
        if (this.timeoutId != -1) clearTimeout(this.timeoutId);

        // stfu tsc
        // @ts-ignore
        this.timeoutId = setTimeout(async () => {
            let value = this.action();
            if (typeof value == "object" && "then" in value)
                await <Promise<void>>value;

            this.timeoutId = -1;
        }, this.warmup)
    }
}